// Comprehensive HTML period report. Self-contained — every style is
// inlined into one <style> block so the user can open the file in
// any browser (or attach it to an email) without external assets.
//
// Output: ONE long HTML string covering every module the app tracks
// — workout, phoenix lifestyle, health, vitals, finance, phases,
// journey (private recovery log, owner-only) and learning. Built
// for print-to-PDF: every section breaks cleanly at page boundaries
// (CSS page-break rules), the cover page sits on its own sheet, and
// the table of contents links jump within the document.
//
// Pure builder over fetched rows. No DOM, no network, no formatting
// hooks — the page fires the queries in parallel and hands the
// arrays in here.

const L = {
  ar: {
    appName: 'فينيكس تراكر',
    title: 'تقرير شامل',
    subtitle: 'تقرير تفصيلى عن نشاطك خلال الفترة',
    coverFor: 'الاسم',
    range: 'الفترة',
    generatedOn: 'تاريخ التقرير',
    pageLabel: 'الصفحة',
    days: 'يوم',
    minutes: 'دقيقة',
    none: 'لا توجد بيانات لهذه الفترة',
    toc: 'المحتويات',

    sectionExec: 'ملخص تنفيذى',
    sectionWorkout: 'التمارين',
    sectionPhoenix: 'نمط الحياة',
    sectionHealth: 'الملف الصحي',
    sectionVitals: 'القياسات الحيوية',
    sectionFinance: 'الماليات',
    sectionPhases: 'المراحل',
    sectionJourney: 'الرحلة',
    sectionLearning: 'التعلم',
    sectionAppendix: 'الملحق',

    execSummary: 'نظرة سريعة على أبرز مؤشرات الفترة.',
    metric: 'المؤشر',
    value: 'القيمة',
    label: 'البند',
    notes: 'ملاحظات',
    date: 'التاريخ',
    time: 'الوقت',
    name: 'الاسم',
    type: 'النوع',
    status: 'الحالة',
    amount: 'المبلغ',
    total: 'الإجمالي',
    avg: 'المتوسط',
    delta: 'الفرق',
    rate: 'النسبة',
    count: 'العدد',
    progress: 'التقدم',

    workoutSessions: 'الجلسات',
    workoutSets: 'سيتات (بدون إحماء)',
    workoutVolume: 'إجمالي الحمل',
    workoutCardio: 'إجمالي الكارديو',
    workoutActiveDays: 'أيام نشاط',
    workoutSessionList: 'تفاصيل الجلسات',
    workoutTopExercises: 'أكثر التمارين تكرارا',
    workoutExercise: 'التمرين',
    workoutReps: 'تكرار',
    workoutWeight: 'وزن',
    workoutAvgWeight: 'متوسط الوزن',
    workoutMaxWeight: 'أعلى وزن',
    workoutCardioType: 'نوع الكارديو',
    workoutDuration: 'المدة',

    phoenixWeight: 'الوزن',
    phoenixWeightStart: 'بداية الفترة',
    phoenixWeightEnd: 'نهاية الفترة',
    phoenixWeightMin: 'أدنى وزن',
    phoenixWeightMax: 'أعلى وزن',
    phoenixWater: 'المياه',
    phoenixWaterAvg: 'متوسط يومي',
    phoenixWaterHit: 'الالتزام بالهدف',
    phoenixWaterDaily: 'تفصيل يومي',
    phoenixMeals: 'الوجبات',
    phoenixMealsLogged: 'وجبات مسجّلة',
    phoenixMealDays: 'أيام مسجّلة',
    phoenixAvgKcal: 'متوسط السعرات اليومي',
    phoenixAvgProtein: 'متوسط البروتين اليومي',
    phoenixAvgCarbs: 'متوسط الكاربس اليومي',
    phoenixAvgFat: 'متوسط الدهون اليومي',

    healthMeds: 'الأدوية',
    healthSupps: 'الفيتامينات والمكملات',
    healthConds: 'الحالات الصحية',
    healthMedTaken: 'تم تناولها',
    healthMedExpected: 'المتوقع',
    healthSchedule: 'مواعيد',
    healthDosage: 'الجرعة',
    healthStarted: 'بدأت في',
    healthStopped: 'توقفت في',
    healthDoctor: 'الطبيب',
    healthDiagnosed: 'تاريخ التشخيص',
    healthActive: 'نشطة',
    healthInactive: 'متوقفة',

    vitalsBp: 'ضغط الدم',
    vitalsHr: 'النبض',
    vitalsGluc: 'سكر الدم',
    vitalsContext: 'السياق',
    vitalsReading: 'القراءة',

    financeBalance: 'الرصيد',
    financeBalanceStart: 'بداية',
    financeBalanceEnd: 'نهاية',
    financeIncome: 'مصادر الدخل',
    financeFixed: 'مصروفات ثابتة',
    financeVariable: 'مصروفات متغيرة',
    financeInstallments: 'الأقساط',
    financeSpecial: 'التزامات خاصة',
    financeTargets: 'الأهداف المالية',
    financeProvider: 'الجهة',
    financeRemaining: 'متبقي',
    financeMonths: 'شهر',
    financeMonthly: 'شهريا',
    financeMonthlyNet: 'صافى شهرى تقريبى',
    financeNoBalance: 'لا توجد قراءات رصيد',
    targetAchieved: 'محقق',
    targetInProgress: 'جارى',
    targetMissed: 'فائت',
    targetActive: 'نشط',
    targetType: 'نوع الهدف',
    targetValue: 'القيمة المستهدفة',

    phasesActive: 'المرحلة الحالية',
    phasesHistory: 'مراحل سابقة',
    phasesStart: 'البداية',
    phasesEnd: 'النهاية',
    phasesStartWeight: 'وزن البداية',
    phasesGoalWeight: 'وزن الهدف',
    phasesNoPhase: 'لا توجد مراحل مسجّلة',

    journeyOverview: 'نظرة عامة',
    journeyTotalUrges: 'إجمالى الأحداث',
    journeyResisted: 'تمت المقاومة',
    journeyLapses: 'انتكاسات',
    journeyResistanceRate: 'نسبة المقاومة',
    journeyAvgIntensity: 'متوسط الشدة',
    journeyCheckins: 'تسجيلات يومية',
    journeyAvgMood: 'متوسط المزاج',
    journeyAvgEnergy: 'متوسط الطاقة',
    journeyIntensity: 'الشدة',
    journeyTrigger: 'المحفز',
    journeyResponse: 'الاستجابة',
    journeyLog: 'سجل الأحداث',
    journeyCheckinList: 'تفاصيل التسجيلات',
    journeyMood: 'المزاج',
    journeyEnergy: 'الطاقة',
    journeyUrgesToday: 'حدثت',
    journeyResistedShort: 'مقاومة',
    journeyLapsedShort: 'انتكاسة',

    learningResources: 'الموارد التعليمية',
    learningTopic: 'الموضوع',
    learningTitle: 'العنوان',
    learningType: 'النوع',
    learningCompleted: 'تم الإنجاز',
    learningOf: 'من',
    learningCompletedShort: '✓',

    appendixNote:
      'هذا التقرير يعرض البيانات كما هى مخزّنة فى التطبيق. أى تفاصيل مفقودة تعنى أن البيانات لم تُسجَّل لهذه الفترة.',
  },
  en: {
    appName: 'Phoenix Tracker',
    title: 'Comprehensive Report',
    subtitle: 'A detailed report of your activity during the period',
    coverFor: 'Name',
    range: 'Range',
    generatedOn: 'Generated on',
    pageLabel: 'Page',
    days: 'days',
    minutes: 'min',
    none: 'No data for this period',
    toc: 'Table of contents',

    sectionExec: 'Executive summary',
    sectionWorkout: 'Workout',
    sectionPhoenix: 'Lifestyle',
    sectionHealth: 'Health profile',
    sectionVitals: 'Vitals',
    sectionFinance: 'Finance',
    sectionPhases: 'Phases',
    sectionJourney: 'Journey',
    sectionLearning: 'Learning',
    sectionAppendix: 'Appendix',

    execSummary: 'A quick read on the key indicators for the period.',
    metric: 'Metric',
    value: 'Value',
    label: 'Item',
    notes: 'Notes',
    date: 'Date',
    time: 'Time',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    amount: 'Amount',
    total: 'Total',
    avg: 'Avg',
    delta: 'Δ',
    rate: 'Rate',
    count: 'Count',
    progress: 'Progress',

    workoutSessions: 'Sessions',
    workoutSets: 'Work sets',
    workoutVolume: 'Total volume',
    workoutCardio: 'Total cardio',
    workoutActiveDays: 'Active days',
    workoutSessionList: 'Session detail',
    workoutTopExercises: 'Most-trained exercises',
    workoutExercise: 'Exercise',
    workoutReps: 'reps',
    workoutWeight: 'weight',
    workoutAvgWeight: 'Avg weight',
    workoutMaxWeight: 'Max weight',
    workoutCardioType: 'Cardio type',
    workoutDuration: 'Duration',

    phoenixWeight: 'Weight',
    phoenixWeightStart: 'Start',
    phoenixWeightEnd: 'End',
    phoenixWeightMin: 'Low',
    phoenixWeightMax: 'High',
    phoenixWater: 'Water',
    phoenixWaterAvg: 'Avg daily',
    phoenixWaterHit: 'Goal hit rate',
    phoenixWaterDaily: 'Daily breakdown',
    phoenixMeals: 'Meals',
    phoenixMealsLogged: 'Meals logged',
    phoenixMealDays: 'Logged days',
    phoenixAvgKcal: 'Avg daily kcal',
    phoenixAvgProtein: 'Avg daily protein',
    phoenixAvgCarbs: 'Avg daily carbs',
    phoenixAvgFat: 'Avg daily fat',

    healthMeds: 'Medications',
    healthSupps: 'Supplements',
    healthConds: 'Conditions',
    healthMedTaken: 'Taken',
    healthMedExpected: 'Expected',
    healthSchedule: 'Schedule',
    healthDosage: 'Dosage',
    healthStarted: 'Started',
    healthStopped: 'Stopped',
    healthDoctor: 'Doctor',
    healthDiagnosed: 'Diagnosed',
    healthActive: 'Active',
    healthInactive: 'Inactive',

    vitalsBp: 'Blood pressure',
    vitalsHr: 'Heart rate',
    vitalsGluc: 'Glucose',
    vitalsContext: 'Context',
    vitalsReading: 'Reading',

    financeBalance: 'Balance',
    financeBalanceStart: 'Start',
    financeBalanceEnd: 'End',
    financeIncome: 'Income sources',
    financeFixed: 'Fixed expenses',
    financeVariable: 'Variable expenses',
    financeInstallments: 'Installments',
    financeSpecial: 'Special obligations',
    financeTargets: 'Financial targets',
    financeProvider: 'Provider',
    financeRemaining: 'Remaining',
    financeMonths: 'mo',
    financeMonthly: 'monthly',
    financeMonthlyNet: 'Approx. monthly net',
    financeNoBalance: 'No balance readings',
    targetAchieved: 'Achieved',
    targetInProgress: 'In progress',
    targetMissed: 'Missed',
    targetActive: 'Active',
    targetType: 'Target type',
    targetValue: 'Target value',

    phasesActive: 'Active phase',
    phasesHistory: 'Past phases',
    phasesStart: 'Start',
    phasesEnd: 'End',
    phasesStartWeight: 'Start weight',
    phasesGoalWeight: 'Goal weight',
    phasesNoPhase: 'No phases recorded',

    journeyOverview: 'Overview',
    journeyTotalUrges: 'Total events',
    journeyResisted: 'Resisted',
    journeyLapses: 'Lapses',
    journeyResistanceRate: 'Resistance rate',
    journeyAvgIntensity: 'Avg intensity',
    journeyCheckins: 'Daily check-ins',
    journeyAvgMood: 'Avg mood',
    journeyAvgEnergy: 'Avg energy',
    journeyIntensity: 'Intensity',
    journeyTrigger: 'Trigger',
    journeyResponse: 'Response',
    journeyLog: 'Event log',
    journeyCheckinList: 'Check-in detail',
    journeyMood: 'Mood',
    journeyEnergy: 'Energy',
    journeyUrgesToday: 'Urge',
    journeyResistedShort: 'resisted',
    journeyLapsedShort: 'lapsed',

    learningResources: 'Learning resources',
    learningTopic: 'Topic',
    learningTitle: 'Title',
    learningType: 'Type',
    learningCompleted: 'Completed',
    learningOf: 'of',
    learningCompletedShort: '✓',

    appendixNote:
      'This report reflects the data stored in the app as-is. Any missing details mean nothing was logged during this period.',
  },
}

// ----- helpers ------------------------------------------------------------

function pick(language) {
  return L[language === 'ar' ? 'ar' : 'en']
}

function esc(s) {
  if (s == null) return ''
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function num(n, decimals = 0) {
  if (n == null || isNaN(n)) return '—'
  return Number(n).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

function dateOnly(d) {
  if (!d) return ''
  return String(d).slice(0, 10)
}

function inRange(date, startIso, endIso) {
  if (!date) return false
  const d = dateOnly(date)
  return d >= startIso && d <= endIso
}

function daysBetweenIso(startIso, endIso) {
  const a = new Date(`${startIso}T00:00:00Z`)
  const b = new Date(`${endIso}T00:00:00Z`)
  return Math.max(1, Math.round((b - a) / 86400000) + 1)
}

// Tiny sparkline as inline SVG. Pure visual cue — no axes, no
// labels. Falls back to nothing when there's less than 2 points.
function sparkline(values, { width = 320, height = 60, stroke = '#f97316' } = {}) {
  const filtered = values.filter((v) => v != null && !isNaN(v))
  if (filtered.length < 2) return ''
  const min = Math.min(...filtered)
  const max = Math.max(...filtered)
  const range = max - min || 1
  const stepX = width / (filtered.length - 1)
  const points = filtered.map((v, i) => {
    const x = i * stepX
    const y = height - ((v - min) / range) * height
    return `${x.toFixed(1)},${y.toFixed(1)}`
  }).join(' ')
  return `<svg class="spark" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="${points}" fill="none" stroke="${stroke}" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/></svg>`
}

// Simple table builder: headers + rows of HTML strings.
function table(headers, rows) {
  if (!rows.length) return ''
  const thead = headers.map((h) => `<th>${esc(h)}</th>`).join('')
  const tbody = rows.map((r) => `<tr>${r.map((c) => `<td>${c}</td>`).join('')}</tr>`).join('')
  return `<table class="data"><thead><tr>${thead}</tr></thead><tbody>${tbody}</tbody></table>`
}

function kv(rows) {
  // rows: [{ label, value, hint? }]
  return `<table class="kv">${rows
    .map(
      (r) => `<tr><td class="k">${esc(r.label)}</td><td class="v">${
        r.value ?? '—'
      }${r.hint ? ` <span class="hint">${esc(r.hint)}</span>` : ''}</td></tr>`,
    )
    .join('')}</table>`
}

function statusBadge(status, T) {
  const map = {
    achieved: { cls: 'good', text: T.targetAchieved },
    in_progress: { cls: 'warn', text: T.targetInProgress },
    missed: { cls: 'bad', text: T.targetMissed },
    active: { cls: 'good', text: T.targetActive },
  }
  const cfg = map[status] || { cls: 'muted', text: status || '—' }
  return `<span class="pill ${cfg.cls}">${esc(cfg.text)}</span>`
}

function emptyNote(T) {
  return `<p class="empty">${esc(T.none)}</p>`
}

function sectionHeader(id, title) {
  return `<section id="${id}" class="page"><h2>${esc(title)}</h2>`
}

function sectionFooter() {
  return `</section>`
}

// ----- modules ------------------------------------------------------------

function workoutModule(sessions, startIso, endIso, T) {
  const filtered = (sessions || []).filter((s) => inRange(s.date, startIso, endIso))
  let html = sectionHeader('workout', T.sectionWorkout)
  if (filtered.length === 0) return html + emptyNote(T) + sectionFooter()

  let workSets = 0
  let totalVolume = 0
  let cardioMin = 0
  const activeDays = new Set()
  const cardioBreakdown = new Map()
  const exerciseAgg = new Map()
  for (const s of filtered) {
    activeDays.add(s.date)
    for (const log of s.exercise_logs || []) {
      const exName = log.exercises?.name || log.exercise?.name || '—'
      let agg = exerciseAgg.get(exName)
      if (!agg) {
        agg = { sets: 0, reps: 0, volume: 0, maxWeight: 0, days: new Set() }
        exerciseAgg.set(exName, agg)
      }
      agg.days.add(s.date)
      for (const set of log.sets || []) {
        if (set.is_warmup) continue
        workSets += 1
        const w = Number(set.weight_kg) || 0
        const r = Number(set.reps) || 0
        totalVolume += w * r
        agg.sets += 1
        agg.reps += r
        agg.volume += w * r
        if (w > agg.maxWeight) agg.maxWeight = w
      }
    }
    for (const c of s.cardio_logs || []) {
      const min = Number(c.duration_min) || 0
      cardioMin += min
      const key = c.cardio_type || '—'
      cardioBreakdown.set(key, (cardioBreakdown.get(key) || 0) + min)
    }
  }

  html += `<div class="kpis">
    <div class="kpi"><span class="num">${num(filtered.length)}</span><span class="kpi-label">${esc(T.workoutSessions)}</span></div>
    <div class="kpi"><span class="num">${num(activeDays.size)}</span><span class="kpi-label">${esc(T.workoutActiveDays)}</span></div>
    <div class="kpi"><span class="num">${num(workSets)}</span><span class="kpi-label">${esc(T.workoutSets)}</span></div>
    <div class="kpi"><span class="num">${num(totalVolume)}</span><span class="kpi-label">${esc(T.workoutVolume)} (kg)</span></div>
    <div class="kpi"><span class="num">${num(cardioMin)}</span><span class="kpi-label">${esc(T.workoutCardio)} (${esc(T.minutes)})</span></div>
  </div>`

  // Top exercises (top 10 by volume)
  const topExercises = Array.from(exerciseAgg.entries())
    .sort((a, b) => b[1].volume - a[1].volume)
    .slice(0, 10)
  if (topExercises.length > 0) {
    html += `<h3>${esc(T.workoutTopExercises)}</h3>`
    html += table(
      [T.workoutExercise, T.workoutSets, T.workoutReps, T.workoutVolume + ' (kg)', T.workoutMaxWeight + ' (kg)'],
      topExercises.map(([name, a]) => [
        esc(name),
        num(a.sets),
        num(a.reps),
        num(a.volume),
        num(a.maxWeight, 1),
      ]),
    )
  }

  if (cardioBreakdown.size > 0) {
    html += `<h3>${esc(T.workoutCardio)}</h3>`
    html += table(
      [T.workoutCardioType, T.workoutDuration + ' (' + T.minutes + ')'],
      Array.from(cardioBreakdown.entries())
        .sort((a, b) => b[1] - a[1])
        .map(([k, v]) => [esc(k), num(v)]),
    )
  }

  // Per-session detail (chronological)
  html += `<h3>${esc(T.workoutSessionList)}</h3>`
  const sessionRows = [...filtered].sort((a, b) => (a.date < b.date ? -1 : 1))
  html += table(
    [T.date, T.type, T.workoutDuration + ' (' + T.minutes + ')', T.workoutSets, T.workoutVolume + ' (kg)', T.workoutCardio + ' (' + T.minutes + ')'],
    sessionRows.map((s) => {
      let sets = 0
      let vol = 0
      let cardio = 0
      for (const log of s.exercise_logs || []) {
        for (const set of log.sets || []) {
          if (set.is_warmup) continue
          sets += 1
          vol += (Number(set.weight_kg) || 0) * (Number(set.reps) || 0)
        }
      }
      for (const c of s.cardio_logs || []) cardio += Number(c.duration_min) || 0
      return [
        esc(s.date),
        esc(s.session_type || '—'),
        num(s.duration_min || 0),
        num(sets),
        num(vol),
        num(cardio),
      ]
    }),
  )

  return html + sectionFooter()
}

function phoenixModule({ weights, waters, meals, waterGoalMl }, startIso, endIso, T) {
  let html = sectionHeader('phoenix', T.sectionPhoenix)

  // Weight
  const wRows = (weights || [])
    .filter((w) => inRange(w.date, startIso, endIso))
    .sort((a, b) => (a.date < b.date ? -1 : 1))
  html += `<h3>${esc(T.phoenixWeight)}</h3>`
  if (wRows.length === 0) {
    html += emptyNote(T)
  } else {
    const vals = wRows.map((w) => Number(w.weight)).filter((v) => !isNaN(v))
    const wStart = wRows[0]
    const wEnd = wRows[wRows.length - 1]
    const wMin = Math.min(...vals)
    const wMax = Math.max(...vals)
    const delta = Number(wEnd.weight) - Number(wStart.weight)
    html += kv([
      { label: T.phoenixWeightStart, value: `${num(wStart.weight, 1)} kg`, hint: wStart.date },
      { label: T.phoenixWeightEnd, value: `${num(wEnd.weight, 1)} kg`, hint: wEnd.date },
      { label: T.delta, value: `<span class="${delta < 0 ? 'good' : delta > 0 ? 'bad' : ''}">${delta >= 0 ? '+' : ''}${num(delta, 1)} kg</span>` },
      { label: T.phoenixWeightMin, value: `${num(wMin, 1)} kg` },
      { label: T.phoenixWeightMax, value: `${num(wMax, 1)} kg` },
    ])
    html += `<div class="spark-wrap">${sparkline(vals, { stroke: '#f97316' })}</div>`
  }

  // Water (daily breakdown)
  const waterByDay = new Map()
  for (const w of waters || []) {
    if (!inRange(w.date, startIso, endIso)) continue
    waterByDay.set(w.date, (waterByDay.get(w.date) || 0) + (Number(w.amount_ml) || 0))
  }
  html += `<h3>${esc(T.phoenixWater)}</h3>`
  if (waterByDay.size === 0) {
    html += emptyNote(T)
  } else {
    const total = Array.from(waterByDay.values()).reduce((s, v) => s + v, 0)
    const avg = total / waterByDay.size
    const goalMl = Number(waterGoalMl) || 3000
    const daysHitGoal = Array.from(waterByDay.values()).filter((v) => v >= goalMl).length
    const hitRate = (daysHitGoal / waterByDay.size) * 100
    html += kv([
      { label: T.phoenixWaterAvg, value: `${num(avg)} ml` },
      { label: T.phoenixWaterHit, value: `${num(hitRate)}% (${daysHitGoal} / ${waterByDay.size} ${T.days})` },
      { label: T.total, value: `${num(total)} ml` },
    ])
    const sortedDays = Array.from(waterByDay.entries()).sort((a, b) => (a[0] < b[0] ? -1 : 1))
    html += `<div class="spark-wrap">${sparkline(sortedDays.map(([, v]) => v), { stroke: '#0ea5e9' })}</div>`
    html += `<details><summary>${esc(T.phoenixWaterDaily)}</summary>`
    html += table(
      [T.date, T.value + ' (ml)'],
      sortedDays.map(([d, v]) => [esc(d), `<span class="${v >= goalMl ? 'good' : 'muted'}">${num(v)}</span>`]),
    )
    html += `</details>`
  }

  // Meals
  const inrangeMeals = (meals || []).filter((m) => inRange(m.date, startIso, endIso))
  html += `<h3>${esc(T.phoenixMeals)}</h3>`
  if (inrangeMeals.length === 0) {
    html += emptyNote(T)
  } else {
    const mealDays = new Set(inrangeMeals.map((m) => m.date))
    const sums = inrangeMeals.reduce(
      (acc, m) => {
        acc.kcal += Number(m.kcal) || 0
        acc.protein += Number(m.protein_g) || 0
        acc.carbs += Number(m.carbs_g) || 0
        acc.fat += Number(m.fat_g) || 0
        return acc
      },
      { kcal: 0, protein: 0, carbs: 0, fat: 0 },
    )
    const dDays = mealDays.size
    html += kv([
      { label: T.phoenixMealsLogged, value: num(inrangeMeals.length) },
      { label: T.phoenixMealDays, value: `${dDays} / ${daysBetweenIso(startIso, endIso)}` },
      { label: T.phoenixAvgKcal, value: num(sums.kcal / dDays) },
      { label: T.phoenixAvgProtein, value: `${num(sums.protein / dDays)} g` },
      { label: T.phoenixAvgCarbs, value: `${num(sums.carbs / dDays)} g` },
      { label: T.phoenixAvgFat, value: `${num(sums.fat / dDays)} g` },
    ])
  }

  return html + sectionFooter()
}

function adherenceFor(items, intakeLog, startIso, endIso) {
  return (items || [])
    .filter((it) => Array.isArray(it.schedule_times) && it.schedule_times.length > 0)
    .map((it) => {
      const itemStart = (it.started_at && it.started_at > startIso) ? it.started_at : startIso
      const itemEnd = (it.stopped_at && it.stopped_at < endIso) ? it.stopped_at : endIso
      const overlapDays = itemEnd < itemStart ? 0 : daysBetweenIso(itemStart, itemEnd)
      const expected = overlapDays * it.schedule_times.length
      const taken = (intakeLog || []).filter(
        (l) => l.item_id === it.id && inRange(l.date, startIso, endIso),
      ).length
      const rate = expected > 0 ? (taken / expected) * 100 : 0
      return { ...it, taken, expected, rate }
    })
}

function adherenceTable(items, T) {
  if (items.length === 0) return emptyNote(T)
  return table(
    [T.name, T.healthDosage, T.healthSchedule, `${T.healthMedTaken} / ${T.healthMedExpected}`, T.rate],
    items.map((r) => [
      esc(r.name),
      esc(r.dosage || '—'),
      esc((r.schedule_times || []).join(', ') || '—'),
      `${r.taken} / ${r.expected}`,
      `<span class="${r.rate >= 80 ? 'good' : r.rate >= 50 ? 'warn' : 'bad'}">${num(r.rate)}%</span>`,
    ]),
  )
}

function healthModule({ medications, supplements, conditions, intakeLog }, startIso, endIso, T) {
  let html = sectionHeader('health', T.sectionHealth)

  const meds = adherenceFor(medications, (intakeLog || []).filter((l) => l.item_kind === 'medication'), startIso, endIso)
  const supps = adherenceFor(supplements, (intakeLog || []).filter((l) => l.item_kind === 'supplement'), startIso, endIso)

  html += `<h3>${esc(T.healthMeds)}</h3>${adherenceTable(meds, T)}`
  html += `<h3>${esc(T.healthSupps)}</h3>${adherenceTable(supps, T)}`

  html += `<h3>${esc(T.healthConds)}</h3>`
  if (!conditions || conditions.length === 0) {
    html += emptyNote(T)
  } else {
    html += table(
      [T.name, T.healthDoctor, T.healthDiagnosed, T.status, T.notes],
      conditions.map((c) => [
        esc(c.name),
        esc(c.doctor || '—'),
        esc(c.diagnosed_at || '—'),
        c.is_active
          ? `<span class="pill good">${esc(T.healthActive)}</span>`
          : `<span class="pill muted">${esc(T.healthInactive)}</span>`,
        esc(c.notes || ''),
      ]),
    )
  }

  return html + sectionFooter()
}

function vitalsModule(vitalsByKind, startIso, endIso, T) {
  let html = sectionHeader('vitals', T.sectionVitals)
  const kinds = Object.keys(vitalsByKind || {})
  if (kinds.length === 0) return html + emptyNote(T) + sectionFooter()

  const kindLabel = {
    blood_pressure: T.vitalsBp,
    heart_rate: T.vitalsHr,
    glucose: T.vitalsGluc,
  }

  for (const kind of kinds) {
    const arr = (vitalsByKind[kind] || [])
      .filter((v) => inRange(v.measured_at, startIso, endIso))
      .sort((a, b) => (a.measured_at < b.measured_at ? -1 : 1))
    if (arr.length === 0) continue
    html += `<h3>${esc(kindLabel[kind] || kind)}</h3>`
    html += table(
      [T.date, T.vitalsReading, T.vitalsContext],
      arr.map((v) => {
        let reading = ''
        if (kind === 'blood_pressure') reading = `${v.systolic}/${v.diastolic} mmHg`
        else if (kind === 'heart_rate') reading = `${v.bpm} bpm`
        else if (kind === 'glucose') reading = `${v.glucose_mg_dl} mg/dL`
        return [
          esc((v.measured_at || '').slice(0, 16).replace('T', ' ')),
          esc(reading),
          esc(v.context || '—'),
        ]
      }),
    )
  }
  return html + sectionFooter()
}

function financeModule(
  { balanceEntries, targets, incomeSources, fixedExpenses, installments, specialObligations, variableExpense },
  startIso, endIso, T,
) {
  let html = sectionHeader('finance', T.sectionFinance)

  // Balance trend
  const inrange = (balanceEntries || [])
    .filter((b) => inRange(b.as_of_date, startIso, endIso))
    .sort((a, b) => (a.as_of_date < b.as_of_date ? -1 : 1))
  html += `<h3>${esc(T.financeBalance)}</h3>`
  if (inrange.length === 0) {
    html += emptyNote(T)
  } else {
    const bStart = inrange[0]
    const bEnd = inrange[inrange.length - 1]
    const delta = Number(bEnd.amount) - Number(bStart.amount)
    html += kv([
      { label: T.financeBalanceStart, value: `${num(bStart.amount)} SAR`, hint: bStart.as_of_date },
      { label: T.financeBalanceEnd, value: `${num(bEnd.amount)} SAR`, hint: bEnd.as_of_date },
      { label: T.delta, value: `<span class="${delta >= 0 ? 'good' : 'bad'}">${delta >= 0 ? '+' : ''}${num(delta)} SAR</span>` },
    ])
    html += `<div class="spark-wrap">${sparkline(inrange.map((b) => Number(b.amount)), { stroke: '#16a34a' })}</div>`
  }

  // Monthly net snapshot (from current setup — not period-bound)
  const totalIncome = (incomeSources || [])
    .filter((i) => i.status === 'active' && i.frequency === 'monthly')
    .reduce((s, i) => s + (Number(i.amount) || 0), 0)
  const totalFixed = (fixedExpenses || [])
    .filter((e) => e.status === 'active')
    .reduce((s, e) => s + (Number(e.amount) || 0), 0)
  const totalInst = (installments || [])
    .filter((i) => i.status === 'active' && (i.remaining_months ?? 0) > 0)
    .reduce((s, i) => s + (Number(i.monthly_amount) || 0), 0)
  const variable = Number(variableExpense?.monthly_estimate) || 0
  const monthlyNet = totalIncome - totalFixed - totalInst - variable
  if (totalIncome || totalFixed || totalInst || variable) {
    html += `<h3>${esc(T.financeMonthlyNet)}</h3>`
    html += kv([
      { label: T.financeIncome, value: `<span class="good">+${num(totalIncome)} SAR</span>` },
      { label: T.financeFixed, value: `<span class="bad">-${num(totalFixed)} SAR</span>` },
      { label: T.financeInstallments, value: `<span class="bad">-${num(totalInst)} SAR</span>` },
      { label: T.financeVariable, value: `<span class="bad">-${num(variable)} SAR</span>` },
      { label: T.financeMonthlyNet, value: `<span class="${monthlyNet >= 0 ? 'good' : 'bad'}"><strong>${monthlyNet >= 0 ? '+' : ''}${num(monthlyNet)} SAR</strong></span>` },
    ])
  }

  if ((incomeSources || []).length > 0) {
    html += `<h3>${esc(T.financeIncome)}</h3>`
    html += table(
      [T.name, T.amount + ' (SAR)', T.type, T.status],
      incomeSources.map((i) => [
        esc(i.name),
        num(i.amount),
        esc(i.frequency || '—'),
        esc(i.status || '—'),
      ]),
    )
  }

  if ((fixedExpenses || []).length > 0) {
    html += `<h3>${esc(T.financeFixed)}</h3>`
    html += table(
      [T.name, T.amount + ' (SAR)', T.type, T.status],
      fixedExpenses.map((e) => [
        esc(e.name),
        num(e.amount),
        esc(e.category || '—'),
        esc(e.status || '—'),
      ]),
    )
  }

  if ((installments || []).length > 0) {
    html += `<h3>${esc(T.financeInstallments)}</h3>`
    html += table(
      [T.financeProvider, T.label, T.financeMonthly + ' (SAR)', T.financeRemaining, T.status],
      installments.map((i) => [
        esc(i.provider),
        esc(i.label || '—'),
        num(i.monthly_amount),
        `${i.remaining_months} / ${i.total_months} ${T.financeMonths}`,
        esc(i.status || '—'),
      ]),
    )
  }

  if ((specialObligations || []).length > 0) {
    html += `<h3>${esc(T.financeSpecial)}</h3>`
    html += table(
      [T.name, T.type, T.amount + ' (SAR)', T.status],
      specialObligations.map((s) => [
        esc(s.name),
        esc(s.kind || '—'),
        num(s.amount),
        esc(s.status || '—'),
      ]),
    )
  }

  if ((targets || []).length > 0) {
    html += `<h3>${esc(T.financeTargets)}</h3>`
    html += table(
      [T.name, T.targetType, T.targetValue, T.status, T.date],
      targets.map((t) => [
        esc(t.name),
        esc(t.type || '—'),
        t.target_value ? num(t.target_value) + ' SAR' : '—',
        statusBadge(t.status, T),
        esc(t.achieved_at || t.target_date || '—'),
      ]),
    )
  }

  return html + sectionFooter()
}

function phasesModule(phases, T) {
  let html = sectionHeader('phases', T.sectionPhases)
  if (!phases || phases.length === 0) {
    return html + `<p class="empty">${esc(T.phasesNoPhase)}</p>` + sectionFooter()
  }
  const active = phases.filter((p) => !p.end_date)
  const past = phases.filter((p) => p.end_date)
  if (active.length > 0) {
    html += `<h3>${esc(T.phasesActive)}</h3>`
    html += table(
      [T.name, T.type, T.phasesStart, T.phasesStartWeight, T.phasesGoalWeight, T.notes],
      active.map((p) => [
        esc(p.name || p.phase_type),
        esc(p.phase_type),
        esc(p.start_date),
        p.start_weight_kg ? `${num(p.start_weight_kg, 1)} kg` : '—',
        p.goal_weight_kg ? `${num(p.goal_weight_kg, 1)} kg` : '—',
        esc(p.notes || ''),
      ]),
    )
  }
  if (past.length > 0) {
    html += `<h3>${esc(T.phasesHistory)}</h3>`
    html += table(
      [T.name, T.type, T.phasesStart, T.phasesEnd, T.phasesStartWeight, T.phasesGoalWeight],
      past.map((p) => [
        esc(p.name || p.phase_type),
        esc(p.phase_type),
        esc(p.start_date),
        esc(p.end_date),
        p.start_weight_kg ? `${num(p.start_weight_kg, 1)} kg` : '—',
        p.goal_weight_kg ? `${num(p.goal_weight_kg, 1)} kg` : '—',
      ]),
    )
  }
  return html + sectionFooter()
}

function journeyModule({ urges, checkins }, startIso, endIso, T) {
  let html = sectionHeader('journey', T.sectionJourney)
  const inrUrges = (urges || []).filter((u) => inRange(u.recorded_at, startIso, endIso))
  const inrCheckins = (checkins || []).filter((c) => inRange(c.date, startIso, endIso))
  if (inrUrges.length === 0 && inrCheckins.length === 0) {
    return html + emptyNote(T) + sectionFooter()
  }

  const resisted = inrUrges.filter((u) => u.response === 'resisted').length
  const lapsed = inrUrges.filter((u) => u.response === 'lapsed').length
  const total = inrUrges.length
  const resistanceRate = total > 0 ? (resisted / total) * 100 : null
  const intensities = inrUrges.map((u) => Number(u.intensity)).filter((v) => v != null && !isNaN(v))
  const avgIntensity = intensities.length > 0 ? intensities.reduce((s, v) => s + v, 0) / intensities.length : null
  const moods = inrCheckins.map((c) => Number(c.mood)).filter((v) => v != null && !isNaN(v))
  const energies = inrCheckins.map((c) => Number(c.energy)).filter((v) => v != null && !isNaN(v))
  const avgMood = moods.length > 0 ? moods.reduce((s, v) => s + v, 0) / moods.length : null
  const avgEnergy = energies.length > 0 ? energies.reduce((s, v) => s + v, 0) / energies.length : null

  html += `<h3>${esc(T.journeyOverview)}</h3>`
  html += `<div class="kpis">
    <div class="kpi"><span class="num">${num(total)}</span><span class="kpi-label">${esc(T.journeyTotalUrges)}</span></div>
    <div class="kpi good"><span class="num">${num(resisted)}</span><span class="kpi-label">${esc(T.journeyResisted)}</span></div>
    <div class="kpi bad"><span class="num">${num(lapsed)}</span><span class="kpi-label">${esc(T.journeyLapses)}</span></div>
    <div class="kpi"><span class="num">${resistanceRate == null ? '—' : num(resistanceRate) + '%'}</span><span class="kpi-label">${esc(T.journeyResistanceRate)}</span></div>
    <div class="kpi"><span class="num">${avgIntensity == null ? '—' : num(avgIntensity, 1)}</span><span class="kpi-label">${esc(T.journeyAvgIntensity)}</span></div>
    <div class="kpi"><span class="num">${num(inrCheckins.length)}</span><span class="kpi-label">${esc(T.journeyCheckins)}</span></div>
    <div class="kpi"><span class="num">${avgMood == null ? '—' : num(avgMood, 1)}</span><span class="kpi-label">${esc(T.journeyAvgMood)}</span></div>
    <div class="kpi"><span class="num">${avgEnergy == null ? '—' : num(avgEnergy, 1)}</span><span class="kpi-label">${esc(T.journeyAvgEnergy)}</span></div>
  </div>`

  if (inrCheckins.length > 0) {
    const sorted = [...inrCheckins].sort((a, b) => (a.date < b.date ? -1 : 1))
    html += `<div class="spark-wrap">${sparkline(sorted.map((c) => Number(c.mood) || null), { stroke: '#a855f7' })}</div>`
    html += `<h3>${esc(T.journeyCheckinList)}</h3>`
    html += table(
      [T.date, T.journeyMood, T.journeyEnergy, T.journeyUrgesToday, T.notes],
      sorted.map((c) => [
        esc(c.date),
        c.mood != null ? `${c.mood} / 5` : '—',
        c.energy != null ? `${c.energy} / 5` : '—',
        c.urges_today ? `<span class="pill bad">${esc(T.journeyUrgesToday)}</span>` : '—',
        esc(c.notes || ''),
      ]),
    )
  }

  if (inrUrges.length > 0) {
    const sorted = [...inrUrges].sort((a, b) => (a.recorded_at < b.recorded_at ? -1 : 1))
    html += `<h3>${esc(T.journeyLog)}</h3>`
    html += table(
      [T.date, T.journeyIntensity, T.journeyTrigger, T.journeyResponse, T.notes],
      sorted.map((u) => [
        esc((u.recorded_at || '').slice(0, 16).replace('T', ' ')),
        u.intensity != null ? `${u.intensity} / 5` : '—',
        esc(u.trigger_text || ''),
        u.response === 'resisted'
          ? `<span class="pill good">${esc(T.journeyResistedShort)}</span>`
          : `<span class="pill bad">${esc(T.journeyLapsedShort)}</span>`,
        esc(u.notes || ''),
      ]),
    )
  }

  return html + sectionFooter()
}

function learningModule(resources, T) {
  let html = sectionHeader('learning', T.sectionLearning)
  if (!resources || resources.length === 0) return html + emptyNote(T) + sectionFooter()
  const byTopic = new Map()
  for (const r of resources) {
    const key = r.topic || '—'
    if (!byTopic.has(key)) byTopic.set(key, [])
    byTopic.get(key).push(r)
  }
  for (const [topic, rows] of byTopic) {
    const done = rows.filter((r) => r.completed).length
    html += `<h3>${esc(topic)} <span class="muted">(${done} ${esc(T.learningOf)} ${rows.length})</span></h3>`
    html += table(
      [T.learningTitle, T.learningType, T.status],
      rows.map((r) => [
        r.url ? `<a href="${esc(r.url)}">${esc(r.title)}</a>` : esc(r.title),
        esc(r.type || '—'),
        r.completed ? `<span class="pill good">${esc(T.learningCompletedShort)}</span>` : '—',
      ]),
    )
  }
  return html + sectionFooter()
}

function executiveSummary(allData, startIso, endIso, T) {
  // High-level highlights extracted from the bigger sections.
  const rows = []
  const sessions = (allData.sessions || []).filter((s) => inRange(s.date, startIso, endIso))
  if (sessions.length > 0) rows.push({ label: T.sectionWorkout, value: `${sessions.length} ${T.workoutSessions.toLowerCase()}` })

  const wRows = (allData.weights || [])
    .filter((w) => inRange(w.date, startIso, endIso))
    .sort((a, b) => (a.date < b.date ? -1 : 1))
  if (wRows.length >= 2) {
    const d = Number(wRows[wRows.length - 1].weight) - Number(wRows[0].weight)
    rows.push({ label: T.phoenixWeight, value: `<span class="${d <= 0 ? 'good' : 'bad'}">${d >= 0 ? '+' : ''}${num(d, 1)} kg</span>` })
  }
  const meals = (allData.meals || []).filter((m) => inRange(m.date, startIso, endIso))
  if (meals.length > 0) rows.push({ label: T.phoenixMeals, value: `${meals.length} ${T.phoenixMealsLogged.toLowerCase()}` })

  const balance = (allData.balanceEntries || [])
    .filter((b) => inRange(b.as_of_date, startIso, endIso))
    .sort((a, b) => (a.as_of_date < b.as_of_date ? -1 : 1))
  if (balance.length >= 2) {
    const d = Number(balance[balance.length - 1].amount) - Number(balance[0].amount)
    rows.push({ label: T.financeBalance, value: `<span class="${d >= 0 ? 'good' : 'bad'}">${d >= 0 ? '+' : ''}${num(d)} SAR</span>` })
  }
  const urges = (allData.recoveryUrges || []).filter((u) => inRange(u.recorded_at, startIso, endIso))
  if (urges.length > 0) {
    const resisted = urges.filter((u) => u.response === 'resisted').length
    const rate = (resisted / urges.length) * 100
    rows.push({ label: T.sectionJourney, value: `<span class="${rate >= 70 ? 'good' : rate >= 40 ? 'warn' : 'bad'}">${num(rate)}% ${T.journeyResistanceRate.toLowerCase()}</span>` })
  }

  let html = sectionHeader('exec', T.sectionExec)
  html += `<p class="lede">${esc(T.execSummary)}</p>`
  if (rows.length === 0) html += emptyNote(T)
  else html += kv(rows)
  return html + sectionFooter()
}

// ----- top-level builder --------------------------------------------------

export function buildPeriodReportHtml({
  startIso,
  endIso,
  language = 'en',
  userName,
  data,
  includeJourney = false,
}) {
  const T = pick(language)
  const isAr = language === 'ar'
  const dir = isAr ? 'rtl' : 'ltr'
  const today = new Date().toLocaleDateString('en-CA')

  const sections = []
  sections.push(executiveSummary(data, startIso, endIso, T))
  sections.push(workoutModule(data.sessions, startIso, endIso, T))
  sections.push(phoenixModule({
    weights: data.weights,
    waters: data.waters,
    meals: data.meals,
    waterGoalMl: data.waterGoalMl,
  }, startIso, endIso, T))
  sections.push(healthModule({
    medications: data.medications,
    supplements: data.supplements,
    conditions: data.conditions,
    intakeLog: data.intakeLog,
  }, startIso, endIso, T))
  sections.push(vitalsModule(data.vitalsByKind, startIso, endIso, T))
  sections.push(financeModule({
    balanceEntries: data.balanceEntries,
    targets: data.targets,
    incomeSources: data.incomeSources,
    fixedExpenses: data.fixedExpenses,
    installments: data.installments,
    specialObligations: data.specialObligations,
    variableExpense: data.variableExpense,
  }, startIso, endIso, T))
  sections.push(phasesModule(data.phases, T))
  if (includeJourney) {
    sections.push(journeyModule({
      urges: data.recoveryUrges,
      checkins: data.recoveryCheckins,
    }, startIso, endIso, T))
  }
  sections.push(learningModule(data.learningResources, T))

  const tocItems = [
    ['exec', T.sectionExec],
    ['workout', T.sectionWorkout],
    ['phoenix', T.sectionPhoenix],
    ['health', T.sectionHealth],
    ['vitals', T.sectionVitals],
    ['finance', T.sectionFinance],
    ['phases', T.sectionPhases],
    ...(includeJourney ? [['journey', T.sectionJourney]] : []),
    ['learning', T.sectionLearning],
  ]

  return `<!DOCTYPE html>
<html lang="${esc(language)}" dir="${dir}">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${esc(T.title)} · ${esc(startIso)} → ${esc(endIso)}</title>
<style>
  :root {
    --ink: #0f172a;
    --muted: #64748b;
    --soft: #f1f5f9;
    --line: #e2e8f0;
    --brand: #f97316;
    --brand-dark: #c2410c;
    --good: #16a34a;
    --bad: #dc2626;
    --warn: #d97706;
    --bg: #ffffff;
  }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; width: 100%; max-width: 100%; overflow-x: hidden; }
  body {
    font-family: ${isAr ? '"Cairo", "Tajawal",' : ''} -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    color: var(--ink);
    background: var(--bg);
    line-height: 1.55;
    font-size: 14px;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  img, svg, video { max-width: 100%; height: auto; }
  .wrap { max-width: 880px; margin: 0 auto; padding: 32px 28px 64px; }
  /* Cover */
  .cover {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: linear-gradient(135deg, #fff7ed 0%, #fffbeb 100%);
    page-break-after: always;
    padding: 80px 28px;
  }
  .cover .brand-tag {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 6px 14px; border-radius: 999px;
    background: var(--brand); color: white;
    font-size: 12px; font-weight: 600; letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  .cover h1 { font-size: 48px; margin: 8px 0 6px; color: var(--ink); }
  .cover .subtitle { color: var(--muted); font-size: 16px; margin: 0 0 32px; max-width: 520px; }
  .cover .meta {
    display: grid; grid-template-columns: max-content 1fr; gap: 8px 20px;
    margin-top: 24px; text-align: ${isAr ? 'right' : 'left'};
    background: white; border: 1px solid var(--line); border-radius: 12px;
    padding: 20px 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    width: 100%; max-width: 480px;
  }
  .cover .meta .v { min-width: 0; word-break: break-word; }
  .cover .meta .k { color: var(--muted); font-size: 13px; }
  .cover .meta .v { font-weight: 600; }
  /* TOC */
  .toc { page-break-after: always; padding: 64px 0 0; }
  .toc h2 { font-size: 24px; margin: 0 0 24px; }
  .toc ol { padding-${isAr ? 'right' : 'left'}: 20px; line-height: 2.2; }
  .toc a { color: var(--ink); text-decoration: none; border-bottom: 1px dotted var(--line); }
  .toc a:hover { color: var(--brand); }
  /* Sections */
  section.page { page-break-inside: avoid; padding-top: 32px; }
  section.page h2 {
    font-size: 26px; margin: 0 0 18px; padding-bottom: 8px;
    border-bottom: 3px solid var(--brand); color: var(--ink);
  }
  section.page h3 {
    font-size: 16px; margin: 24px 0 10px; color: var(--brand-dark);
    text-transform: uppercase; letter-spacing: 0.04em;
  }
  .lede { color: var(--muted); margin: -4px 0 18px; }
  /* KV table */
  table.kv { border-collapse: collapse; width: 100%; margin: 8px 0 16px; }
  table.kv td { padding: 8px 12px; border-bottom: 1px solid var(--line); vertical-align: middle; }
  table.kv td.k { color: var(--muted); width: 42%; font-size: 13px; }
  table.kv td.v { font-weight: 600; }
  .hint { color: var(--muted); font-weight: 400; font-size: 12px; }
  /* Data table */
  table.data {
    border-collapse: collapse; width: 100%; max-width: 100%;
    margin: 10px 0 18px;
    font-size: 13px;
    table-layout: auto;
  }
  table.data thead th {
    text-align: ${isAr ? 'right' : 'left'};
    padding: 8px 10px;
    background: var(--soft);
    border-bottom: 2px solid var(--line);
    font-weight: 600;
    color: var(--ink);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    word-break: keep-all;
  }
  table.data tbody td {
    padding: 8px 10px;
    border-bottom: 1px solid var(--line);
    vertical-align: top;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  table.data tbody tr:nth-child(even) td { background: rgba(241,245,249,0.4); }
  table.data tbody a { color: var(--brand-dark); text-decoration: none; }
  /* KPIs */
  .kpis {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 10px; margin: 12px 0 18px;
  }
  .kpi {
    border: 1px solid var(--line); border-radius: 10px;
    padding: 12px 14px; text-align: ${isAr ? 'right' : 'left'};
    background: white;
  }
  .kpi .num { display: block; font-size: 22px; font-weight: 700; color: var(--ink); }
  .kpi .kpi-label { display: block; font-size: 11px; color: var(--muted); text-transform: uppercase; letter-spacing: 0.04em; margin-top: 4px; }
  .kpi.good .num { color: var(--good); }
  .kpi.bad .num { color: var(--bad); }
  /* Pills + status colours */
  .pill { display: inline-block; padding: 2px 10px; border-radius: 999px; font-size: 11px; font-weight: 600; letter-spacing: 0.02em; }
  .pill.good { background: rgba(22,163,74,0.12); color: var(--good); }
  .pill.bad  { background: rgba(220,38,38,0.12); color: var(--bad); }
  .pill.warn { background: rgba(217,119,6,0.12); color: var(--warn); }
  .pill.muted{ background: var(--soft); color: var(--muted); }
  .good { color: var(--good); }
  .bad  { color: var(--bad); }
  .warn { color: var(--warn); }
  .muted{ color: var(--muted); }
  .empty { color: var(--muted); font-style: italic; padding: 8px 0; }
  /* Sparklines */
  .spark-wrap { margin: 8px 0 16px; }
  .spark { width: 100%; height: auto; max-height: 80px; }
  /* Details/summary collapsible (still renders flat when printing) */
  details { margin: 6px 0 12px; }
  details > summary { cursor: pointer; color: var(--muted); font-size: 12px; padding: 4px 0; }
  details[open] > summary { color: var(--brand-dark); margin-bottom: 8px; }
  /* Footer */
  .footer {
    margin-top: 48px; padding-top: 16px;
    border-top: 1px solid var(--line);
    color: var(--muted); font-size: 12px; text-align: center;
  }
  @media (max-width: 640px) {
    .wrap { padding: 16px 12px 40px; }
    .cover { padding: 48px 14px; min-height: auto; }
    .cover h1 { font-size: 32px; }
    .cover .subtitle { font-size: 14px; }
    .cover .meta { padding: 14px 16px; gap: 6px 14px; }
    section.page h2 { font-size: 22px; }
    section.page h3 { font-size: 14px; }
    table.data, table.kv { font-size: 12px; }
    table.data thead th, table.data tbody td { padding: 6px 6px; }
    table.kv td { padding: 6px 8px; }
    .kpis { grid-template-columns: repeat(auto-fit, minmax(110px, 1fr)); gap: 8px; }
    .kpi { padding: 10px 12px; }
    .kpi .num { font-size: 18px; }
  }
  @media print {
    .wrap { padding: 0 16px; }
    section.page { page-break-before: always; }
    .toc, .cover { page-break-after: always; }
    body { font-size: 12px; }
    .kpi { break-inside: avoid; }
    table.data { break-inside: auto; }
    table.data tr { break-inside: avoid; }
    details { display: block; }
    details > summary { display: none; }
    details > *:not(summary) { display: block !important; }
  }
</style>
</head>
<body>
<div class="cover">
  <span class="brand-tag">${esc(T.appName)}</span>
  <h1>${esc(T.title)}</h1>
  <p class="subtitle">${esc(T.subtitle)}</p>
  <div class="meta">
    ${userName ? `<div class="k">${esc(T.coverFor)}</div><div class="v">${esc(userName)}</div>` : ''}
    <div class="k">${esc(T.range)}</div><div class="v" dir="ltr">${esc(startIso)} → ${esc(endIso)} (${daysBetweenIso(startIso, endIso)} ${esc(T.days)})</div>
    <div class="k">${esc(T.generatedOn)}</div><div class="v" dir="ltr">${esc(today)}</div>
  </div>
</div>
<div class="wrap">
  <nav class="toc">
    <h2>${esc(T.toc)}</h2>
    <ol>
      ${tocItems.map(([id, label]) => `<li><a href="#${id}">${esc(label)}</a></li>`).join('')}
    </ol>
  </nav>
  ${sections.join('\n')}
  <div class="footer">
    ${esc(T.appendixNote)}<br>
    ${esc(T.appName)} · ${esc(today)}
  </div>
</div>
</body>
</html>
`
}

export function suggestedReportFilenameHtml(language, startIso, endIso) {
  const base = language === 'ar' ? 'تقرير' : 'period-report'
  return `${base}-${startIso}_${endIso}.html`
}
